import { render, staticRenderFns } from "./scrollTabs.vue?vue&type=template&id=550fca77&scoped=true&"
import script from "./scrollTabs.vue?vue&type=script&lang=js&"
export * from "./scrollTabs.vue?vue&type=script&lang=js&"
import style0 from "./scrollTabs.vue?vue&type=style&index=0&id=550fca77&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "550fca77",
  null
  
)

export default component.exports